<template>
  <div>
    <v-autocomplete
      v-bind="$attrs"
      ref="driverSelect"
      class="driver-select"
      item-text="phone"
      return-object
      hide-no-data
      :dense="dense"
      :hide-details="hideDetails"
      :items="foundDrivers"
      :search-input.sync="search"
      :value="phone"
      :menu-props="{ maxHeight: 200 }"
      :loading="loading"
      :disabled="!hasPermission"
      @change="onChange"
    >
      <template v-if="clearable" #append>
        <div class="d-flex align-items-center">
          <v-btn
            v-if="phone && hasPermission"
            class="delete-btn"
            x-small
            icon
            @click="onDelete"
          >
            <v-icon size="20">
              mdi-close-circle-outline
            </v-icon>
          </v-btn>

          <v-icon>
            mdi-menu-down
          </v-icon>
        </div>
      </template>
    </v-autocomplete>

    <select-new-status-dialog
      v-model="confirmDelete"
      @save="$emit('change', { driver_id: null, car_status: $event })"
    />
  </div>
</template>

<script>
import SelectNewStatusDialog from '@/components/workers-board/SelectNewStatusDialog.vue';

export default {
  components: { SelectNewStatusDialog },
  props: {
    phone: {
      type: String,
      default: '',
    },
    noStatus: {
      type: Boolean,
      default: false,
    },
    permission: {
      type: [String, null],
      default: null,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    loading: false,
    confirmDelete: false,
    search: '',
    foundDrivers: [],
  }),
  computed: {
    hasPermission() {
      return this.$can(this.permission);
    },
  },
  watch: {
    phone: {
      immediate: true,
      handler(val) {
        setTimeout(() => {
          this.search = val;
        });
      },
    },
    search(val) {
      if (!val) return;
      if (this.phone === val) return;

      this.searchDrivers(val);
    },
  },
  methods: {
    async searchDrivers(value) {
      this.loading = true;
      const drivers = await this.$store.dispatch(
        'workers-board/searchExistingDrivers',
        value,
      );

      this.foundDrivers = drivers;
      this.loading = false;
    },
    onChange({ id, name, phone }) {
      this.$emit('change', {
        driver_id: id,
        name,
        phone,
        car_status: '1',
      });

      const input = this.$refs.driverSelect.$el.querySelector('input');
      input.blur();
    },
    onDelete() {
      if (this.noStatus) {
        this.$emit('change', { driver_id: null });
        return;
      }

      this.confirmDelete = true;
    },
  },
};
</script>

<style lang="scss">
.driver-select {
  width: 130px;
  // margin-top: 0;

  .v-select__slot input {
    font-size: 12px;
    margin-top: 2px;
    margin-bottom: 2px;
  }
}

.delete-btn {
  margin-top: 2px;
}

.v-input .mdi-close-circle-outline {
  font-size: 20px;
}

.v-input__append-inner {
  padding-left: 0 !important;
}

.v-input__append-outer {
  margin-left: 0 !important;
}
</style>
